import { TableBody as MuiTableBody } from "@mui/material";
import { useTranslation } from "src/hooks";
import TableBodyRow from "./components/TableBodyRow";
import { setSingleAddressSelection } from "../helpers/selectionHelpers";
import { useBatchContractSweepPreviewContext } from "src/views/AssetManagement/BatchContractSweep/contexts";

function TableBody() {
  const {
    sendingAddressesMap,
    setSendingAddressesMap,
    submitParams,
    toDisplayAmountWithCurrency,
  } = useBatchContractSweepPreviewContext();

  const { t } = useTranslation("enumConstants");

  return (
    <MuiTableBody>
      {Array.from(sendingAddressesMap.entries()).map(
        ([sendingAddress, senderInfo], index) => (
          <TableBodyRow
            key={sendingAddress}
            serialNumber={index + 1}
            sendingAddress={sendingAddress}
            senderInfo={senderInfo}
            spenderAddress={submitParams.spenderAddress}
            t={t}
            toDisplayAmountWithCurrency={toDisplayAmountWithCurrency}
            onToggleAddress={(address, isChecked) => {
              setSendingAddressesMap((prev) =>
                setSingleAddressSelection(prev, address, isChecked),
              );
            }}
          />
        ),
      )}
    </MuiTableBody>
  );
}

export default TableBody;
